module.exports = __webpack_public_path__ + "img/gnu_smart_gallery4.3d4bf1da.jpg";